import React, { useContext } from 'react'
import WishlistContext from '~/context/WishlistContext'
import { Link } from 'gatsby'
import { kebabCase } from 'lodash'
import cartIcon from '../../../img/cart-white.svg'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../../../utils/fontawesome'

const LineItem = props => {
  const { line_item } = props
  const {
    removeLineItem,
    wishlistStore: { client, checkout }
  } = useContext(WishlistContext)

  const product = line_item.variant.image ? (
    <ProductWrapper>
      <Link to={`/product/${kebabCase(line_item.title)}`}>
        <Image
          src={line_item.variant.image.src}
          alt={`${line_item.title} product shot`}
          style={{ height: 'auto', boxShadow: '0 0 10px rgba(0,0,0,.1)' }}
        />
        <div className='button is-primary is-marginless' style={{ position: 'absolute', bottom: '40%', right: '0' }}>
          <img src={cartIcon} alt='Warenkorb' style={{ width: '25px' }} />
        </div>

      </Link>
    </ProductWrapper>
  ) : null

  const selectedOptions = line_item.variant.selectedOptions
    ? line_item.variant.selectedOptions.map(
      option => `${option.name}: ${option.value} `
    )
    : null

  const handleRemove = () => {
    removeLineItem(client, checkout.id, line_item.id)
  }

  return (
    <>
      <div>
        {/*
        <div className='columns is-mobile'>
          <div className='column is-5'>
            <label className='label'>Produkt</label>
          </div>
          <div className='column is-3 has-text-centered'>
            <label className='label'>Menge</label>
          </div>
          <div className='column is-3 has-text-centered'>
            <label className='label'>Preis</label>
          </div>
          <div className='column is-1' />
        </div>
        */}
        <div className='columns is-multiline is-centered is-vcentered'>
          <div className='column is-5' style={{ maxWidth: '250px', margin: '0 auto' }}>

            {product}

            <RemoveButtonWrapper>
              <FontAwesomeIcon icon='times' className='has-text-primary is-pulled-right' onClick={handleRemove} />
            </RemoveButtonWrapper>
            {/*
            <p>
              {line_item.title}
              {`  `}
              {line_item.variant.title === !'Default Title'
                ? line_item.variant.title
                : ''}
              <br />
              {selectedOptions}
            </p>
            */}
          </div>
        </div>
      </div>
    </>
  )
}

export default LineItem

const ProductWrapper = styled.div`
  position: relative;
  height: auto;
  border-radius: 3px;

  @media(min-width: 779px){
    .detailsAndBuy{
      display: none;
      width: 100%;
      position: absolute;
      bottom: 0;
      right: 0;
      border: none;
      font-size: 1.4rem;
      transform: translate(100%, 100%);
      transition: all 0.2s linear;
    }
    &:hover{
      .detailsAndBuy{
        display: block;
        transform: translate(0,0);

      }
    }
  }
  @media(max-width: 779px){
    .detailsAndBuy{
      display: block;
      width: 100%;
      position: absolute;
      bottom: 0;
      right: 0;
      border: none;
      font-size: 1.4rem;
    }
  }
`


const RemoveButtonWrapper = styled.div`
  margin-top: .5rem;
  margin-bottom: 1.5rem;
  &:hover{
    cursor: pointer;
  }
`

const Image = styled.img`
  max-width: 100%;
  height: 200px;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  // margin-bottom: 1.45rem;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.15);
  // transition: transform .5s ease;
  // &:hover{
  // transform: scale(1.01);
  // }
`
